export default __webpack_public_path__ + "static/sedwards-e67cbd8346d8c60e7250c49fb78389d5.jpg";